import { createSelector } from 'reselect';
import { ModuleType } from '../../types/modules';
import {
  ProfileSkin,
  premiumSkins,
  officialSkin,
  customSkin,
  ProfileSkinsSlice,
} from '../../types/profileSkins';
import { getModuleDataByModuleType } from './modules';
import { profileSkinFromProps } from '../../utils/profileSkins';

const getState = (state): ProfileSkinsSlice => state.profileSkins;

export const getActiveSkin = createSelector([getState], state => {
  return state.activeSkin;
});

export const getCustomSkin = createSelector([getState], state => {
  return state.customSkin || customSkin;
});

export const isSkinSelectorShown = state => getState(state).skinSelectorShown;

export const isSkinSaving = state => getState(state).isSkinSaving;

export const getProfileSkin = (state): ProfileSkin | undefined => {
  // active skin comes first when the selector is open
  const activeSkin = getActiveSkin(state);
  if (activeSkin && isSkinSelectorShown(state)) {
    return activeSkin;
  }

  // get the skin from the module config
  const moduleData = getModuleDataByModuleType(
    state,
    ModuleType.COVER_DEVIATION
  );
  if (!moduleData) {
    return undefined;
  }
  const skinId = moduleData?.profileSkin?.templateName;

  if (skinId) {
    if (skinId === 'official') {
      return officialSkin;
    }
    if (skinId === 'custom') {
      return getCustomSkin(state);
    }

    const profileSkin = moduleData.profileSkin;

    // TODO: profile_skins_papi clean up the hardcoded templates search below once all user-selected profile skins have been
    //  migrated in the database. Note that the `imageUrl` field being present means this is a new backend driven skin.
    if (profileSkin && profileSkin.imageUrl) {
      return profileSkinFromProps({
        skinId,
        imageUrl: profileSkin.imageUrl,
        imageDisplayMode: profileSkin.imageDisplayMode,
        theme: profileSkin.theme,
      });
    }

    return premiumSkins.find(s => s.skinId === profileSkin.templateName);
  }
  return undefined;
};
